import type { WageTerm } from './types.js';

/** 해당 날짜에 유효한 가장 최근 요율을 반환한다. 원본 행은 수정하지 않는다. */
export function termFor(wageTerms: WageTerm[], workplaceId: string, date: string): WageTerm | undefined {
  return wageTerms
    .filter((term) => term.workplaceId === workplaceId && term.effectiveFrom <= date)
    .sort((left, right) => left.effectiveFrom.localeCompare(right.effectiveFrom) || left.createdAt.localeCompare(right.createdAt))
    .at(-1);
}
